import React, { useEffect, useMemo, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import UserProfile from '../../components/UserProfile'
import ConfirmTable from '../../components/ConfirmTable'
import axios from 'axios'
import { formatDate } from '../buyer/BuyerRequest'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {
  CommonReasonTextarea,
  DatefilterFn,
  ValidateAPI,
  changeDateFormat,
  convertToLocalDate,
  getDateofMonday,
  getPossibleShipWeek,
  getPresentShipWeek,
  getStartDate,
  handlePODetailsClick,
  makeSWformat,
  reasonCodes,
  reasonCodesEN,
  reasonCodesMN,
  updateActionHistory,
  validateShipWeekInput,
  validateShipWeekInput1
} from '../../utils/Utils'
import { getWeek, getWeekDifferenceStatus } from '../buyer/NewPoList'
import Loading from '../../components/Loading'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import PopupModal from '../../components/PopupModal'
import PopupBanner from '../../components/PopupBanner'
import { CartState } from '../../Context/Context'
import { formatDateFit } from '../buyer/BuyerRequestDetails'
import ReasonCodeList, { ReasonCodeView } from '../../components/ReasonCodeList'
import PopUpPastDue from '../../components/PopUpPastDue'
import { checkvalidpastDue } from '../../components/vendor/ExpediteActionComp'
import axiosInstance from '../../api/axiosInstance'
import { ErrorHandler } from '../../utils/errorHandlers';

export const weeksInBetween = (startWeekYear, endWeekYear) => {

  const [startWeek, startYear] = startWeekYear?.split('.').map(Number)
  const [endWeek, endYear] = endWeekYear?.split('.').map(Number)

  if (!startYear || !startWeek || !endYear || !endWeek) {
    return 0
  }

  const startWeeks = startYear * 52 + startWeek
  const endWeeks = endYear * 52 + endWeek

  const difference = endWeeks - startWeeks

  return difference
}

const ConfirmPo = () => {
  const navigate = useNavigate()
  const [inputsw, setinputsw] = useState('')
  const [showConfirmOrdersModal, setShowConfirmOrdersModal] = useState(false)
  const [showpastDueModel, setShowPastDueModel] = useState(false)
  const [showPopUpForPast, setShowForPast] = useState(false)
  const [showChangeRequestBanner, setShowChangeRequestBanner] = useState(false)
  const [showConfirmOrdersBanner, setshowConfirmOrdersBanner] = useState(false)
  const [bannerMessage, setBannerMessage] = useState('')
  const [editCrIdResponse, setEditCrIdResponse] = useState('')
  const [editPoRow, setEditPORow] = useState('')
  const [poRow, setPoRow] = useState('')
  const [crIdResponse, setCrIdResponse] = useState('')
  const [showRequestChangeModal, setShowRequestChangeModal] = useState(false)
  const user = JSON.parse(localStorage.getItem('userData'))
  const [selectedRowArray, setSelectedRowArray] = useState([])
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(false)
  const [showReasonCode, setShowReasonCode] = useState(false)
  const [reasonCodeValue, setreasonCodeValue] = useState({
    "reasonCodeId": "",
    "reasonCodeText": ""
  })
  const [date, setDate] = useState(new Date())
  const [secondReason, setSecondReason] = useState('')
  const [requestSW, setRequestSW] = useState('')
  const [requestDC, setRequestDC] = useState('')
  const [comment, setComment] = useState('')
  const [dc_list, setDCList] = useState(
    JSON.parse(sessionStorage.getItem('dcList'))
  )
  const [submitting, setSubmitting] = useState(false)
  const [rowSelection, setRowSelection] = useState({})
  const { updateDataCount } = CartState()
  const { t } = useTranslation()
  const datePickerRef = useRef(null)
  const inputRef = useRef(null)
  const [validSw, setValidSw] = useState(false)
  const [poMessage, setPoMessage] = useState(false)
  const [validationMessage, setValidationMessage] = useState('')
  const tableId = 'ConfirmTable' // Define tableId here
  const [errorMessage, setErrorMessage] = useState('');
  const [reasonMessage, setReasonMessage] = useState('');
  const otherReasonCode = reasonCodeValue?.reasonCodeText === 'Others'
  const {
    SelectDC,
    SelectedSW,
    Comment_load,
    POConfirmOrders,
    Home,
    ConfirmPOOrders,
    RequestChange,
    ConfirmOrders,
    Loading1,
    PleaseselectReasoncodefortheselectedorders,
    ReasonCode,
    Selectareason,
    Changetype,
    Selectatype,
    DC,
    Shipweek,
    PleaseSelectDC, REQDC, REQSW, Pleaseselectachangerequest, Ifpricediscrepancyreachouttovendormanagerviaemail, BulkOrderSelected, Change, SelectNewSW, REQSWDate, SelectNewSWDate, EntervalidSW, Confirm,

    Price,
    Quantity,
    // RequestChange:"请求更改",
    Cancel,
    Submitting_load,
    Typehereindetail
  } = t('ConfirmPOpage')
  const handleCRDetailsClick = (value) => {
    const detailsUrl = `/vendor/po_change_requests/request_details/${value}`
    const popupWindow = window.open(
      detailsUrl,
      '_blank',
      'width=1100,height=800,resizable=yes,scrollbars=yes'
    )
    if (popupWindow) {
      popupWindow.focus()
    }
  }
  const headers = {
    CR: t('ConfirmPOpage.CR'),
    PONUMBER: t('ConfirmPOpage.PONUMBER'),
    SKU: t('ConfirmPOpage.SKU'),
    UPC: t('ConfirmPOpage.UPC'),
    DESCRIPTION: t('ConfirmPOpage.DESCRIPTION'),
    // REQSW: t('ConfirmPOpage.REQSW'),
    CHANGEDSW: t('ConfirmPOpage.CHANGEDSW'),
    // CURSW: t('ConfirmPOpage.CURSW'),
    CURRSW: t('POList.CURRENTSW'),
    DC: t('ConfirmPOpage.DC'),
    QUANTITY: t('ConfirmPOpage.QUANTITY'),
    VENDORRESPONSE: t('ConfirmPOpage.VENDORRESPONSE'),
    CREATEDAT: t('ConfirmPOpage.CREATEDAT'),
    REQDC: t('ConfirmPOpage.REQDC'),
    STATUS: t('ConfirmPOpage.STATUS'),
    ORGSW: t('ConfirmPOpage.ORGSW'),
    INVENTORYANALYST: t('POList.INVENTORYANALYST'),
    UNITCOST: t('POList.UNITCOST'),
    EXTENDEDCOST: t('POList.EXTENDEDCOST'),
  }
  const columns = useMemo(
    () => [
      {
        header: headers.CR,
        accessorKey: 'id_open_request',
        cell: (info) => (
          <p
            className='underline cursor-pointer text-blue-500'
            onClick={() => handleCRDetailsClick(info?.getValue())}
          >
            {info?.getValue()}
          </p>
        ),
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.PONUMBER,
        accessorKey: 'po_number',
        cell: (info) => {
          return (
            <p
              className='underline cursor-pointer text-blue-500'
              onClick={() => handlePODetailsClick('vendor', info?.getValue())}
            >
              {info?.getValue()}
            </p>
          )
        },
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.SKU,
        // accessorKey: 'sku',
        accessorFn: row => {
          const v = row.sku;

          // Normalize blank, space, null, undefined → "BLANK"
          return !v || v.trim() === "" ? "BLANK" : v;
        },
        cell: ({ row }) => {
          return (
            row?.original?.sku && <span>{row?.original?.sku}</span>
          )
        },
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id); // This returns "BLANK" for empty cells
          return value.includes(cellValue);
        },
      },
      {
        header: headers.UPC,
        accessorKey: 'upc',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.DESCRIPTION,
        // accessorKey: 'description',
        accessorFn: row => {
          const v = row.description;

          // Normalize blank, space, null, undefined → "BLANK"
          return !v || v.trim() === "" ? "BLANK" : v;
        },
        cell: ({ row }) => {
          return (
            row?.original?.description && <span>{row?.original?.description}</span>
          )
        },
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id); // This returns "BLANK" for empty cells
          return value.includes(cellValue);
        },
        size: 100
      },
      {
        header: headers.CHANGEDSW,
        // accessorKey: 'requested_ship_week',
        accessorFn: row => {
          const v = row.requested_ship_week;

          // Normalize blank, space, null, undefined → "BLANK"
          return !v || v.trim() === "" ? "BLANK" : v;
        },
        cell: ({ row }) => {
          return (
            row?.original?.requested_ship_week && <span>{row?.original?.requested_ship_week}</span>
          )
        },
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id); // This returns "BLANK" for empty cells
          return value.includes(cellValue);
        },
      },
      {
        header: headers.CURRSW,
        accessorFn: row => {
          const v = row.current_ship_week;

          // Normalize blank, space, null, undefined → "BLANK"
          return !v || v.trim() === "" ? "BLANK" : v;
        },
        cell: ({ row }) => {
          return (
            row?.original?.current_ship_week && <span>{row?.original?.current_ship_week}</span>
          )
        },
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id); // This returns "BLANK" for empty cells
          return value.includes(cellValue);
        },
      },
      {
        header: headers.ORGSW,
        accessorKey: 'original_ship_week',
        accessorFn: row => {
          const v = row.original_ship_week;

          // Normalize blank, space, null, undefined → "BLANK"
          return !v || v.trim() === "" ? "BLANK" : v;
        },
        cell: ({ row }) => {
          return (
            row?.original?.original_ship_week && <span>{row?.original?.original_ship_week}</span>
          )
        },
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id); // This returns "BLANK" for empty cells
          return value.includes(cellValue);
        },
      },
      {
        header: headers.DC,
        accessorKey: 'original_dc',
        accessorFn: row => {
          const v = row.original_dc;

          // Normalize blank, space, null, undefined → "BLANK"
          return !v || v.trim() === "" ? "BLANK" : v;
        },
        cell: ({ row }) => {
          return (
            row?.original?.original_dc && <span>{row?.original?.original_dc}</span>
          )
        },
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id); // This returns "BLANK" for empty cells
          return value.includes(cellValue);
        },
      },
      {
        header: headers.REQDC,
        // accessorKey: 'requested_dc',
        accessorFn: row => {
          const v = row.requested_dc;

          // Normalize blank, space, null, undefined → "BLANK"
          return !v || v.trim() === "" ? "BLANK" : v;
        },
        cell: ({ row }) => {
          return (
            row?.original?.requested_dc && <span>{row?.original?.requested_dc}</span>
          )
        },
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id); // This returns "BLANK" for empty cells
          return value.includes(cellValue);
        },
      },
      {
        header: headers.INVENTORYANALYST,
        // accessorKey: 'inventory_analyst',
        // cell: (info) => info?.getValue() ?? '',
        accessorFn: row => {
          const v = row.inventory_analyst;

          // Normalize blank, space, null, undefined → "BLANK"
          return !v || v.trim() === "" ? "BLANK" : v;
        },
        cell: ({ row }) => {
          return (
            row?.original?.inventory_analyst && <span>{row?.original?.inventory_analyst}</span>
          )
        },
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id); // This returns "BLANK" for empty cells
          return value.includes(cellValue);
        },
        // filterFn: (row, id, value) => {
        //   return value.includes(row.getValue(id))
        // },
        size: 80
      },
      {
        header: headers.UNITCOST,
        accessorKey: 'unitPrice',
        // accessorFn: row => {
        //   const v = row.unitPrice;

        //   // Normalize blank, space, null, undefined → "BLANK"
        //   return !v || v.trim() === "" ? "BLANK" : v;
        // },
        // cell: ({ row }) => {
        //   return (
        //     row?.original?.unitPrice && <span>{row?.original?.unitPrice}</span>
        //   )
        // },
        // filterFn: (row, id, value) => {
        //   const cellValue = row.getValue(id); // This returns "BLANK" for empty cells
        //   return value.includes(cellValue);
        // },
      },
      {
        header: headers.EXTENDEDCOST,
        accessorKey: 'extendedPrice',
        // accessorFn: row => {
        //   const v = row.extendedPrice;

        //   // Normalize blank, space, null, undefined → "BLANK"
        //   return !v || v.trim() === "" ? "BLANK" : v;
        // },
        // cell: ({ row }) => {
        //   return (
        //     row?.original?.extendedPrice && <span>{row?.original?.extendedPrice}</span>
        //   )
        // },
        // filterFn: (row, id, value) => {
        //   const cellValue = row.getValue(id); // This returns "BLANK" for empty cells
        //   return value.includes(cellValue);
        // },
      },
      {
        header: headers.QUANTITY,
        accessorKey: 'original_qty',
        // accessorFn: row => {
        //   const v = row.original_qty;

        //   // Normalize blank, space, null, undefined → "BLANK"
        //   return !v || v.trim() === "" ? "BLANK" : v;
        // },
        // cell: ({ row }) => {
        //   return (
        //     row?.original?.original_qty && <span>{row?.original?.original_qty}</span>
        //   )
        // },
        // filterFn: (row, id, value) => {
        //   const cellValue = row.getValue(id); // This returns "BLANK" for empty cells
        //   return value.includes(cellValue);
        // },
      },
      {
        header: headers.VENDORRESPONSE,
        accessorFn: row => {
          const value = row?.supplier_response;

          if (value == null || String(value).trim() === '') {
            return 'BLANK';
          }

          return value.toUpperCase() === 'REJECTED'
            ? 'Acknowledged PO with exceptions'
            : value;
        },
        cell: ({ row }) => {
          const value = row?.original?.supplier_response;

          if (value == null || String(value).trim() === '') {
            return null;
          }

          return (
            <span>
              {value.toUpperCase() === 'REJECTED'
                ? 'Acknowledged PO with exceptions'
                : value}
            </span>
          );
        },

        filterFn: (row, id, filterValue) => {
          const cellValue = row.getValue(id);

          if (!cellValue || !filterValue) return false;

          const selectedValues = String(filterValue)
            .split(",")
            .map(value => value.trim().toLowerCase());

          return selectedValues.includes(
            String(cellValue).trim().toLowerCase()
          );
        }
      },
      {
        header: headers.STATUS,
        // accessorKey: 'status',
        accessorFn: row => {
          const v = row.status;

          // Normalize blank, space, null, undefined → "BLANK"
          return !v || v.trim() === "" ? "BLANK" : v;
        },
        cell: ({ row }) => {
          return (
            row?.original?.status && <span>{row?.original?.status}</span>
          )
        },
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id); // This returns "BLANK" for empty cells
          return value.includes(cellValue);
        },
      },
      {
        header: headers.CREATEDAT,
        accessorKey: 'created_at',
        cell: (info) => convertToLocalDate(info?.getValue()),
        filterFn: DatefilterFn
      }
    ],
    [headers]
  )

  const handleChangeDate = (date) => {
    setDate(date)
    setRequestSW(getWeek(date))
    setValidSw(false)
    setinputsw(getWeek(date))
  }


  const maxDate = new Date()
  maxDate.setFullYear(maxDate.getFullYear() + 2)
  const renderBlock = (reason) => {
    if (reason === 'dc') {
      return (
        <div className='flex flex-col space-y-2'>
          <label htmlFor='dc delect' className='text-xs font-medium'>
            {PleaseSelectDC}
          </label>
          <select
            className='w-full border border-gray-300 p-2 rounded-md text-xs'
            onChange={(e) => setRequestDC(e?.target?.value)}
          >
            <option value='' selected>
              {SelectDC}
            </option>
            {dc_list?.map((data, index) => (
              <option value={data?.DC_NAME} key={data + index}>
                {data?.DC_NAME}
              </option>
            ))}
          </select>
          <div className='flex items-center p-2'>
            <p className='text-xs'>{REQDC}  </p>
            <p className='text-xs ml-2'>
              <span className='font-medium p-1 px-2 border border-gray-300 rounded-md text-xs'>
                {selectedRowArray[0].original_dc}
              </span>
            </p>
          </div>
        </div>
      )
    } else if (reason === 'Ship_Week') {
      // if (!selectedRowArray.every((item) => item.requested_ship_week === selectedRowArray[0]?.requested_ship_week)) {
      //   return (
      //     <p className="text-xs text-red-500 font-medium">
      //       Selected PO Lines have different current SWs, unable to process this.
      //     </p>
      //   );
      // }
      return (

        <div className='w-full flex flex-col  gap-4 justify-between items-center'>
          <div className='flex items-start gap-5 text-xs font-medium w-full'>
            <div className='w-1/2'>
              <p>{REQSW}</p>
              {selectedRowArray?.length === 1 && (
                <p className='mt-1 border p-1 text-xs w-full bg-gray-300'>
                  {selectedRowArray[0].requested_ship_week}
                </p>
              )}
              {selectedRowArray?.length > 1 && (
                <p className='mt-1 text-xs text-red-500'>{BulkOrderSelected}</p>
              )}
            </div>
            <div className='w-1/2'>
              <p>{SelectNewSW}</p>
              <input
                ref={inputRef}
                type='text'
                className="p-1 mt-1  border text-xs w-full  bg-yellow-300 placeholder-black"
                placeholder='SW.YY(e.g.,00.00)'
                value={inputsw}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.]/g, '')
                  setinputsw(value)
                  const validation = validateShipWeekInput1(
                    value,
                    selectedRowArray[0].requested_ship_week
                  );

                  if (!validation.isValid) {
                    setValidSw(true);
                    setValidationMessage(validation.message);
                  } else {
                    setValidSw(false);
                    setValidationMessage("");
                    const sw = getPossibleShipWeek(value);
                    setRequestSW(makeSWformat(sw));
                    setDate(getDateofMonday(sw));
                    // datePickerRef.current.setFocus();
                  }
                  // if (value.length === 5) {
                  // } else {
                  //   setValidSw(false);
                  //   setValidationMessage("");
                  // }
                }}
              />
            </div>
          </div>

          {/* Divider */}
          <div className="h-px my-2 bg-gray-500 w-full" />

          {/* Lower Section */}
          <div className="flex items-start gap-5 text-xs font-medium w-full">
            {/* REQ SW Date */}
            <div className="w-1/2">
              <p>{REQSWDate}</p>
              {selectedRowArray?.length === 1 && (
                <p className='mt-1 border p-1 text-xs w-full bg-gray-300'>
                  {changeDateFormat(selectedRowArray[0].requested_ship_week)}
                </p>
              )}
              {selectedRowArray?.length > 1 && (
                <p className='mt-1 text-xs text-red-500'>{BulkOrderSelected}</p>
              )}
            </div>
            {/* Select New SW Date */}
            <div className="w-1/2">
              <p>{SelectNewSWDate}</p>
              <DatePicker
                showWeekNumbers
                filterDate={(date) => date.getDay() === 1}
                selected={date}
                onChange={(date) => handleChangeDate(date)}
                className="p-1 mt-1 px-2 border text-xs w-full bg-yellow-300"
                calendarStartDay={1}
                ref={datePickerRef}
                showYearDropdown
                minDate={getStartDate(
                  getPossibleShipWeek(selectedRowArray[0].requested_ship_week)
                )}
                maxDate={maxDate}
                excludeDates={[
                  new Date(),
                  // new Date(changeDateFormat(requestSW)),
                ]}
                popperPlacement="top-start"
              />
            </div>
          </div>

          {/* Validation Message */}
          {validSw && <p className="text-red-500 text-xs">{EntervalidSW}</p>}
        </div>

      )
    } else {
      return (
        <div className='w-full flex flex-col gap-2'>
          <label htmlFor='sr_comment' className='text-xs font-medium'>
            {Comment_load}
          </label>
          <textarea
            id='sr_comment'
            className='w-full border border-gray-300 p-2 rounded-md text-xs bg-yellow-300 placeholder-black'
            placeholder={t('ConfirmActionComp.Typehereindetail')}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>
      )
    }
  }

  const fetchData = () => {
    setLoading(true)
    axiosInstance
      .get(
        `/api/get-supplier-cr-type-data?vendorNumber=${user?.supplierId}&crType=CONFIRM`,
        //  ValidateAPI()
      )
      .then((response) => {
        setTableData(response?.data)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        console.error(error)
        if (error.response.status === 401 || error.response.status === 403) {
          navigate('/login-error')
        }
      })
  }

  const closeConfirmOrdersModal = () => {
    setShowConfirmOrdersModal(false)
  }

  const checkpastDue = () => {
    return selectedRowArray?.some((c) => checkvalidpastDue(c?.requested_ship_week))
  }
  const openConfirmOrdersModal = () => {
    if (checkpastDue())
      setShowPastDueModel(true)
    else
      setShowConfirmOrdersModal(true)
  }
  const openEditSW = () => {
    setShowPastDueModel(false)
    setShowReasonCode(true)
    setSecondReason('Ship_Week')
  }
  const openChangeRequestBanner = () => {
    if (selectedRowArray?.length === 1) {
      setShowChangeRequestBanner(true)
      setshowConfirmOrdersBanner(true)
    }
  }

  const closePopUpModal = () => {
    // setPoRow(false)
    // setShowConfirmOrdersModal(false)
    setshowConfirmOrdersBanner(false)
    setShowChangeRequestBanner(false)
  }

  const closeRequestChangeModal = () => {
    setShowRequestChangeModal(false)
  }

  const openRequestChangeModal = () => {
    setShowRequestChangeModal(true)
  }
  const setBannerData = (data) => {
    if (data) {
      const crIdResponse = data.map((item) => item.id_open_request)
      const poRow = data.map((item) => item.po_number)
      setCrIdResponse(crIdResponse)
      setPoRow(poRow)
    }
  }
  const handleConfirmOrders = () => {
    const request_payload = []
    selectedRowArray?.map((row) => {
      const payload = {
        id_open_request: row?.id_open_request,
        vendorNumber: Number(row?.vendor_number),
        vendorName: row?.vendor_name,
        createdBy: row?.inventory_analyst,
        current_ship_week: row?.requested_ship_week,
        original_ship_week: row?.requested_ship_week,
        hft_user_id: 0,
        supplier_contact_id: user?.vendorContactOrcaleId,
        vendor_selected_sw: row?.requested_ship_week
      }
      request_payload?.push(payload)
    })
    setSubmitting(true)
    setShowReasonCode(true)
    axiosInstance
      .post(
        `/api/supplier-confirm-po`,
        request_payload,
        // ValidateAPI()
      )
      .then((response) => {
        setBannerData(response?.data)
        setshowConfirmOrdersBanner(true)
        setBannerMessage('Change Request Accepted Successfully')
        fetchData()
        setShowReasonCode(false)
        // to update order count in side bar
        updateDataCount(user?.supplierId)
        setSubmitting(false)
        setSelectedRowArray([])
        updateActionHistory('Accepted', selectedRowArray)
      })
      .catch((error) => {
        setShowReasonCode(false)
        setSubmitting(false)
        setshowConfirmOrdersBanner(true)
        const message = ErrorHandler(error)
        setBannerMessage(
          <>
            <span style={{ color: 'red', fontWeight: 'bold' }}>{message}</span>
          </>
        )
        // if (error.response.status === 401 || error.response.status === 403) {
        //   navigate('/login-error')
        // }
      })
    closeConfirmOrdersModal()
  }
  const rejectPop = () => {
    setShowReasonCode(true)
    setShowForPast(true)
    closeRequestChangeModal()
  }

  const editConfirm = () => {
    const req_payload = []
    if (otherReasonCode && (!reasonMessage || reasonMessage.trim() === '')) {
      setErrorMessage('Message is Required');
      return;
    }
    if (reasonCodeValue?.reasonCodeText) {
      // const reasons = reasonCodeValue.join(', ')
      if (requestSW?.length > 0 || requestDC?.length > 0) {
        selectedRowArray?.map((item) => {
          const req_obj = {
            hft_cr_id: item?.id_open_request,
            requested_dc: requestDC,
            reason_code_dc: secondReason === 'dc' ? reasonCodeValue?.reasonCodeText : '',
            reasonCodeId: reasonCodeValue?.reasonCodeId || "",
            requested_ship_week: item?.requested_ship_week ?? '',
            reason_code_ship_week: secondReason === 'Ship_Week' ? reasonCodeValue?.reasonCodeText : '',
            supplier_response: 'ACCEPTED',
            current_ship_week: requestSW
              ? requestSW
              : item?.requested_ship_week,
            status: 'OPEN',
            followups: 1,
            vendor_selected_ship_week: requestSW,
            original_ship_week: requestSW
              ? requestSW
              : item?.requested_ship_week,
            // ship_week_delay: Math.abs(
            //   weeksInBetween(requestSW ?? '', item?.requested_ship_week)
            // ),
            ship_week_delay: 0,
            vendorName: item?.vendor_name,
            createdBy: item?.inventory_analyst,
            requestType: 'Confirm',
            reasonDescription : reasonMessage,
            hft_user_id: 0,
            supplier_contact_id: user?.vendorContactOrcaleId
          }
          return req_payload?.push(req_obj)
        })
        setSubmitting(true)
        axiosInstance
          .put(
            `/api/supplier-edit-confirm-po`,
            req_payload,
            // ValidateAPI()
          )
          .then((response) => {
            setBannerData(response?.data)
            setshowConfirmOrdersBanner(true)
            setBannerMessage('Change Request Changed Successfully')
            setRequestDC('')
            setRequestSW('')
            setinputsw('')
            setSubmitting(false)
            setShowReasonCode(false)
            setSecondReason('')
            setreasonCodeValue({
              "reasonCodeId": "",
              "reasonCodeText": ""
            })
            setErrorMessage('')
            setReasonMessage('')
            updateDataCount(user?.supplierId)
            openChangeRequestBanner()
            fetchData()
            updateActionHistory('Accepted', selectedRowArray)

          })
          .catch((error) => {
            setSubmitting(false)
            // if (
            //   error.response.status === 401 ||
            //   error.response.status === 403
            // ) {
            //   navigate('/login-error')
            // }
            setshowConfirmOrdersBanner(true)
            const message = ErrorHandler(error)
            setBannerMessage(
              <>
                <span style={{ color: 'red', fontWeight: 'bold' }}>{message}</span>
              </>
            )
          })
      } else {
        alert(i18next.t('VendorPopUp.Pleaseaddnewvaluebeforesubmitting'))
      }
    } else {
      alert(
        i18next.t(
          'VendorPopUp.PleaseselectReasonCodeChangeTypebeforesubmitting'
        )
      )
    }
  }

  const handleRejectPos = () => {
    const request_payload = []
    const comments_payload = []
    if (!reasonCodeValue?.reasonCodeText?.length > 0)
      return alert(i18next.t('VendorPopUp.Pleaseselectareasoncode'))
    if (!comment)
      return alert(i18next.t('VendorPopUp.Pleaseaddcommentbeforesubmitting'))

    selectedRowArray?.map((row) => {
      const payload = {
        id_open_request: row?.id_open_request,
        vendorNumber: Number(row?.vendor_number),
        reasonCodeShipWeek: reasonCodeValue?.reasonCodeText,
        reasonCodeId: reasonCodeValue?.reasonCodeId,
        vendorName: row?.vendor_name,
        createdBy: row?.inventory_analyst,
        original_ship_week: '',
        vendorComment: comment
      }
      const comment_indi = {
        hftcrid: row?.id_open_request,
        po_number: row?.po_number,
        added_by_role_name: user?.roleName?.split('_')?.[0],
        added_by_name: user?.supplierName,
        comment: comment,
        type: 'Comment',
        SKU: row?.sku
      }
      request_payload?.push(payload)
      comments_payload?.push(comment_indi)
    })

    setSubmitting(true)
    axiosInstance
      .post(
        `/api/supplier-confirm-reject-po`,
        request_payload,
        // ValidateAPI()
      )
      .then((response) => {
        if (response?.data) {
          const editCrIdResponse = response.data.map(
            (item) => item.id_open_request
          )
          const editPoRow = response.data.map((item) => item.po_number)
          setEditPORow(editPoRow)
          setEditCrIdResponse(editCrIdResponse)
          setshowConfirmOrdersBanner(true)
          setBannerMessage('Change Request Rejected Successfully')
        }
        setShowReasonCode(false)
        setSelectedRowArray([])
        setreasonCodeValue({
          "reasonCodeId": "",
          "reasonCodeText": ""
        })
        setShowForPast(false)
        // to update order count in side bar
        updateDataCount(user?.supplierId)
        // setTableData(response?.data)
        fetchData()
        setComment('')
        setSubmitting(false)
        // setShowChangeRequestBanner(true)
        openChangeRequestBanner()
        setBannerData(response?.data)
        setshowConfirmOrdersBanner(true)
        setBannerMessage('Change Request Rejected Successfully')
        // setPopupMessage(i18next.t('VendorPopUp.Orderschangedsuccessfully'));
        updateActionHistory('Rejected', selectedRowArray)
      })
      .catch((error) => {
        // if (error.response.status === 401 || error.response.status === 403) {
        //   navigate('/login-error')
        // }
        setSubmitting(false)
        setshowConfirmOrdersBanner(true)
        const message = ErrorHandler(error)
        setBannerMessage(
          <>
            <span style={{ color: 'red', fontWeight: 'bold' }}>{message}</span>
          </>
        )
      })
  }

  //This is for updat the event when click on hftid it update parent page data from child page
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.updated) {
        fetchData(); // Refresh data when the popup sends an update
        updateDataCount(user?.supplierId)
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
  useEffect(() => {
    fetchData()
  }, [])

  // useEffect(() => {
  //   if (renderBlock && inputRef.current ) {
  //     inputRef.current.focus()
  //   }
  // }, [renderBlock])

  useEffect(() => {
    if (selectedRowArray?.length > 0)
      setDate(getDateofMonday(getPossibleShipWeek(selectedRowArray[0].requested_ship_week)))
  }, [selectedRowArray])
  useEffect(() => {
    const handleClickOutside = () => {
      setshowConfirmOrdersBanner(false)
    }
    if (showConfirmOrdersBanner) {
      window.addEventListener('click', handleClickOutside)
    }
    return () => {
      window.removeEventListener('click', handleClickOutside)
    }
  }, [showConfirmOrdersBanner])
  useEffect(() => {
    if (selectedRowArray?.length > 0) {
      setPoMessage(false) // Hide the error message as soon as an order is selected
    }
  }, [selectedRowArray])

  const selectType = (event) => {
    setreasonCodeValue({
      "reasonCodeId": "",
      "reasonCodeText": ""
    })
    const value = event?.target?.value
    if (value === 'Price') {
      setSecondReason(value)
      // setreasonCodeValue(
      //   'If price discrepancy reach out to vendor manager via email'
      // )
    } else {
      setSecondReason(value)
    }
  }

  const changeOtherReason = (e) => {
    setReasonMessage(e.target.value);
  
    // if (e.target.value.trim()) {
    //   setErrorMessage("");
    // }
  };
  
  return (
    <div className='w-full flex flex-col gap-6 justify-start items-start p-4'>
      <div className='w-full justify-between flex items-center'>
        <div className=''>
          <p className='text-xl'>{POConfirmOrders}</p>
        </div>
        {/* <UserProfile /> */}
      </div>
      <div className='w-full text-xs flex justify-start items-center gap-1 font-medium text-gray-600'>
        <p className='flex gap-1 items-center justify-center'>
          <span
            className='hover:underline cursor-pointer'
            onClick={() => navigate('/vendor')}
          >
            {Home}
          </span>
          <span>{'>'}</span>
        </p>
        <p className='flex gap-1 items-center justify-center'>
          <span>{ConfirmPOOrders}</span>
          {/* <span>{">"}</span> */}
        </p>
        {/* <p className="flex gap-1 items-center justify-center">
            <span>PO Details - {id}</span>
          </p> */}
      </div>

      <div>
        <div className='flex w-full justify-start items-center font-medium text-xs gap-3'>
          <button
            className='px-3 rounded-md bg-green-500 text-white h-[32px]'
            onClick={() => {
              if (selectedRowArray?.length > 0) {
                openConfirmOrdersModal()
                setPoMessage(false)
              } else {
                setPoMessage(true)
              }
            }}
          // disabled={selectedRowArray?.length === 0}
          >
            {Confirm}
          </button>
          <PopupModal
            isOpen={showRequestChangeModal}
            message={i18next.t('PopUpMessage.Doyouwanttocreateachangerequest')}
            onCancel={closeRequestChangeModal}
            cancelText={i18next.t('AcceptModal.Cancel')}
            onConfirm={rejectPop}
            confirmText={i18next.t('AcceptModal.Confirm')}
          />
          <PopUpPastDue
            isOpen={showpastDueModel}
            message={'Selected CR Is In Past Due, Click Confirm, To Change SW and Accept.'}
            onCancel={() => setShowPastDueModel(false)}
            cancelText={i18next.t('AcceptModal.Cancel')}
            onConfirm={openEditSW}
            confirmText={i18next.t('AcceptModal.Confirm')}
          />

          <button
            className='px-3 rounded-md bg-[#ff9500] text-white h-[32px]'
            onClick={() => {
              if (selectedRowArray?.length > 0) {
                openRequestChangeModal()
                setPoMessage(false)
              } else {
                setPoMessage(true)
              }
            }}
          // disabled={selectedRowArray?.length === 0}
          >
            {Change}
          </button>
          <PopupModal
            isOpen={showConfirmOrdersModal}
            message={i18next.t('PopUpMessage.Doyouwanttoconfirmtheseorders')}
            onCancel={closeConfirmOrdersModal}
            cancelText={i18next.t('AcceptModal.Cancel')}
            onConfirm={handleConfirmOrders}
            confirmText={i18next.t('AcceptModal.Confirm')}
          />
        </div>
        {poMessage && (
          <p className='text-red-500 text-xs mt-2'>{Pleaseselectachangerequest}</p>
        )}
      </div>

      {loading ? (
        <div className='w-full min-h-[300px] flex justify-center items-center'>
          <Loading />
        </div>
      ) : (
        <div className='w-full overflow-x-auto'>
          <ConfirmTable
            tableId={tableId}
            tableData={tableData}
            selection={setSelectedRowArray}
            columns={columns}
            updateRowSelectionProp={setRowSelection}
            rowSelectionProp={rowSelection}
          />
        </div>
      )}
      <dialog
        open={showReasonCode}
        className='p-3 inset-0 fixed z-10 bg-black bg-opacity-50 w-full min-h-screen'
      >
        <div className="w-full h-screen p-4 flex justify-center items-center overflow-y-auto">
          {submitting ? (
            <div className='sm:w-[400px] w-[280px] bg-white p-4 rounded-md flex flex-col gap-6'>
              <Loading type={Submitting_load} />
            </div>
          ) : (
            <div  className="sm:w-[400px]
            w-[280px]
            bg-white
            p-4
            rounded-md
            flex
            flex-col
            gap-6
            max-h-[90vh]
            overflow-y-auto
          ">
              <p className='w-full text-center'>
                {PleaseselectReasoncodefortheselectedorders}.
              </p>
              {/* This is to show reasonCodeValue once user selected from list  */}
              <ReasonCodeView
                reasonCodeValue={reasonCodeValue}
                setreasonCodeValue={setreasonCodeValue}
              />
              {/* View End */}
              {showPopUpForPast && <div className='w-full flex flex-col gap-2'>
                <label htmlFor='change_type_dd' className='text-xs font-medium'>
                  {Changetype}
                </label>
                <select
                  onChange={selectType}
                  id='change_type_dd'
                  className='p-2 rounded-md outline-none border border-gray-300 text-xs w-full font-medium'
                  value={secondReason}
                >
                  <option value='' disabled>
                    {Selectatype}
                  </option>
                  {/* <option value='dc'>{DC}</option> */}
                  <option value='Ship_Week'>{Shipweek}</option>
                  <option value='Price'>{Price}</option>
                  <option value='Quantity'>{Quantity}</option>
                </select>
              </div>}
              {/* {secondReason === 'Price' && (
                <div className='w-full flex flex-col items-start gap-2'>
                  <label
                    htmlFor='reason_code_select'
                    className='text-xs font-medium'
                  >
                    {ReasonCode}
                  </label>
                  <select
                    onChange={(e) => setreasonCodeValue(e.target.value)}
                    name='reason_code_select'
                    id='reason_code_select'
                    className='p-2 rounded-md outline-none border border-gray-300 text-xs w-full font-medium'
                    value={reasonCodeValue}
                  >
                    <option
                      selected
                      value='If price discrepancy reach out to vendor manager via email'
                    >
                     {Ifpricediscrepancyreachouttovendormanagerviaemail}
                    </option>
                  </select>
                </div>
              )} */}
              {secondReason?.length > 0 && (
                //  ReasonCode List Component to view all list and select
                <ReasonCodeList
                  reasonCodeValue={reasonCodeValue}
                  setreasonCodeValue={setreasonCodeValue}
                  type={"Confirm"}
                  category={secondReason}
                  setErrorMessage={setErrorMessage}
                  setReasonMessage={setReasonMessage}
                />
              )}
                {otherReasonCode && <div className="w-full flex flex-col">
                  <CommonReasonTextarea
                    value={reasonMessage}
                    error={errorMessage}
                    onChange={changeOtherReason}
                    setErrorMessage={setErrorMessage}
                  />

                </div>}
              {/* End Component */}
              <div className='w-full'>
                {secondReason?.length > 0 &&
                  reasonCodeValue?.reasonCodeText &&
                  renderBlock(secondReason)}
              </div>
              <div className='w-full flex justify-center items-center gap-2 mt-4'>
                {secondReason &&
                  (secondReason === 'dc' || secondReason === 'Ship_Week' ? (
                    <button
                      className={`text-xs font-medium px-2 rounded-md  ${validSw || requestSW?.length === 0 || errorMessage ? 'cursor-not-allowed' : 'cursor-pointer'} h-[38px] text-white bg-[#ff9500] `}
                      onClick={editConfirm}
                    disabled={errorMessage || validSw || requestSW?.length === 0 }
                    >
                      {/* {RequestChange} */}{Change}
                    </button>
                  ) : (
                    <button
                      className={`text-xs font-medium px-2 rounded-md h-[38px] bg-[#ff9500] border text-white `}
                      onClick={handleRejectPos}
                    // disabled={validSw || requestSW?.length === 0}
                    >
                      {/* {RequestChange} */}{Change}
                    </button>
                  ))}
                <button
                  className='text-xs font-medium px-2 rounded-md h-[38px] text-white bg-gray-500 '
                  onClick={() => {
                    setShowReasonCode(false)
                    setreasonCodeValue({
                      "reasonCodeId": "",
                      "reasonCodeText": ""
                    })
                    setRequestSW('')
                    setSecondReason('')
                    setinputsw('')
                    setValidSw('')
                    setShowForPast(false)
                    setErrorMessage('')
                  }}
                >
                  {Cancel}
                </button>
              </div>
            </div>
          )}
        </div>
      </dialog>
      <PopupBanner
        isOpen={showConfirmOrdersBanner}
        message={bannerMessage}
        onCancel={closePopUpModal}
        text={poRow}
        text1={crIdResponse}
      />
    </div>
  )
}

export default ConfirmPo
